<template>
  <dialog-base show-close
               @close="close">
    <div class="mod-secret">
      <div class="title">
        你的宝箱被施了魔法需要暗号才能打开
      </div>
      <div class="form">
        <div class="form-control">
          <input type="text"
                 class="form-input code"
                 v-model="code"
                 placeholder="请输入你的暗号"
                 maxlength="20">
        </div>
        <div class="btn-red">
          <span class="text"
                @click="tapSubmit">确定</span>
        </div>
      </div>
      <div class="tip">
        长按扫描下方二维码<br>
        前往公众号发送“寻宝”获得暗号！
      </div>
      <div class="box-qrcode">
        <img class="ico-qrcode"
             :src="require('@/assets/ico/ico-qrcode.jpg')"
             alt="">
        <!-- <div class="tip">前往公众号获得开箱暗号</div> -->
      </div>
    </div>
  </dialog-base>
</template>

<script>
import DialogBase from '../base'
import mixin from '../mixin'
export default {
  mixins: [mixin],
  components: {
    DialogBase
  },
  data() {
    return {
      code: ''
    }
  },
  mounted() {
    this.$stat({
      event: 'view_secret'
    })
  },
  methods: {
    verify() {
      if (!this.code) {
        this.$toast('请输入暗号')
        return false
      }
      return true
    },
    tapSubmit() {
      this.$stat({
        event: 'click_secret_confirm'
      })
      if (!this.verify()) {
        return
      }
      this.onOk && this.onOk(this.code)
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-secret {
  padding: 270px 105px 0 114px;
  width: 723px;
  height: 878px;
  background-image: url("~@/assets/dialog/dialog-secret.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  .title {
    margin: auto;
    width: 378px;
    text-align: center;
    font-size: 42px;
    font-weight: bold;
    color: #f57906;
  }
  .tip {
    margin-top: 20px;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    color: #ea5404;
  }
  .form {
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .form-control {
      padding-bottom: 8px;
      width: 337px;
      height: 95px;
      background-image: url("~@/assets/ico/btn-white-short.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
      .form-input {
        width: 100%;
        height: 100%;
        text-align: center;
        font-size: 32px;
        font-weight: 500;
        background-color: transparent;
      }
    }
    .btn-red {
      padding-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 156px;
      height: 95px;
      background-image: url("~@/assets/ico/btn-red-short.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
      .text {
        font-size: 32px;
        font-weight: 700;
        color: #ffffff;
        text-shadow: #872c0c 2px 0 2px, #872c0c 0 2px 2px, #872c0c -2px 0 2px,
          #872c0c 0 -2px 2px;
      }
    }
  }
  .box-qrcode {
    margin-top: 40px;
    text-align: center;
    .ico-qrcode {
      width: 166px;
      height: 166px;
    }
  }
}
</style>
